/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/generarDesafioCP';


// ---------------- Saga's response ----------------
function fetchGenerarDesafioCPSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchGenerarDesafioCPError(state) {
  state.response = [];
  state.errorFetchConfirmar = true;
}


const fetchGenerarDesafioCP = createAction('fetchGenerarDesafioCP');

// ------------- connection ------------- //

const generarDesafioCPReducer = createSlice({
  name: 'GenerarDesafioCP',
  initialState,
  reducers: {
    fetchGenerarDesafioCPSuccess,
    fetchGenerarDesafioCPError,
  },
});

export const generarDesafioCPAction = {
  ...generarDesafioCPReducer.actions,
  fetchGenerarDesafioCP,
};

export default generarDesafioCPReducer.reducer;